import React from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { useUnmanagedRoute } from '../../routes/unmanaged-routes/unmanaged-route-context';

interface UnmanagedRouteLinkProps extends LinkProps {}

export function UnmanagedRouteLink({ to, children, ...rest }: UnmanagedRouteLinkProps) {
  const { basePath } = useUnmanagedRoute();

  if (typeof to === 'string') {
    return (
      <Link to={basePath + to} {...rest}>
        {children}
      </Link>
    );
  }

  if (typeof to === 'function') {
    return (
      <Link to={(location) => basePath + to(location)} {...rest}>
        {children}
      </Link>
    );
  }

  return (
    <Link
      to={{
        ...to,
        pathname: basePath + to.pathname,
      }}
      {...rest}
    >
      {children}
    </Link>
  );
}
